import cogoToast from 'cogo-toast';
import api from './apiURL';
const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

// Get All Categories Data
export const getAllCategories = createAsyncThunk(
  'home/getAllCategories',
  async (_, thunkAPI) => {

    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/categories', {
        method: 'GET',
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;

    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

// Get the full category hierarchy (root categories with nested children) for
// the header menus and the category page. Falls back to walking
// /categories/:parentId level by level on an API without the tree endpoint.
export const getCategoryTree = createAsyncThunk(
  'home/getCategoryTree',
  async (_, thunkAPI) => {

    const { rejectWithValue } = thunkAPI;
    const headers = {
      'Content-type': 'application/json; charset=UTF-8',
      'Authorization': `Bearer ${localStorage.getItem("token")}`,
    };

    try {
      const res = await fetch( api + '/api/v1/categories-tree', { method: 'GET', headers });
      if (res.ok) {
        const data = await res.json();
        if (Array.isArray(data.categories)) return data.categories;
      }

      const loadLevel = async (url, depth) => {
        const levelRes = await fetch(url, { method: 'GET', headers });
        const level = (await levelRes.json()).categories || [];
        return Promise.all(level.map(async (category) => ({
          ...category,
          children: depth < 5
            ? await loadLevel(api + '/api/v1/categories/' + category.categoryId, depth + 1)
            : [],
        })));
      };
      return await loadLevel(api + '/api/v1/categories', 0);

    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);


const HomeSlice = createSlice({
    name: "home",
    initialState: {
        categories: [],
        categoryTree: [],
    },
    reducers: {},
    extraReducers: {
      // Get Categories
      [getAllCategories.pending]: (state, action) => {
        state.loading = true;
        state.error = null;
      },
      [getAllCategories.fulfilled]: (state, action) => {

        if (action.payload.success === false){

          // cogoToast.error("Categories Failed in Fullfilled" , {position: "bottom-left"});
        }else{
          state.categories = action.payload.categories;
          // cogoToast.success("Categories Success", {position: "bottom-left"});
        }

      },
      [getAllCategories.rejected]: (state, action) => {
          state.error = action.payload;
          // cogoToast.error("Categories Failed", {position: "bottom-left"});
      },

      // Get Category Tree
      [getCategoryTree.fulfilled]: (state, action) => {
        state.categoryTree = Array.isArray(action.payload) ? action.payload : [];
      },
    }
});


export default HomeSlice.reducer;
